import { BmpHomeOperatingSystem, BmpHomeProcessor, BmpHomeUseCase, BpmHomeTarget } from "domain/softwarePackages";

export const ALL_DEVICE_ITEMS = [
    { value: BpmHomeTarget.LAPTOP_DESKTOP, label: "Onboarding.home.filters.selects.deviceItems.laptopDesktop" },
    { value: BpmHomeTarget.FILE_ACTIVE_DATA, label: "Onboarding.home.filters.selects.deviceItems.fileActiveData" },
    { value: BpmHomeTarget.REMOVABLE_MEDIA, label: "Onboarding.home.filters.selects.deviceItems.removableMedia" },
    { value: BpmHomeTarget.SERVERS, label: "Onboarding.home.filters.selects.deviceItems.servers" },
    { value: BpmHomeTarget.LOOSE_DRIVES, label: "Onboarding.home.filters.selects.deviceItems.looseDrives" },
    { value: BpmHomeTarget.STORAGE, label: "Onboarding.home.filters.selects.deviceItems.storage" },
    { value: BpmHomeTarget.STORAGE_ARRAY, label: "Onboarding.home.filters.selects.deviceItems.storageArray" },
    { value: BpmHomeTarget.VIRTUAL_MACHINE, label: "Onboarding.home.filters.selects.deviceItems.virtualMachine" },
    { value: BpmHomeTarget.SMARTPHONES, label: "Onboarding.home.filters.selects.deviceItems.smartphones" },
    { value: BpmHomeTarget.TABLETS, label: "Onboarding.home.filters.selects.deviceItems.tablets" },
    { value: BpmHomeTarget.WEARABLES, label: "Onboarding.home.filters.selects.deviceItems.wearables" },
    { value: BpmHomeTarget.AIRPOD, label: "Airpod" },
];

export const ALL_OS_ITEMS = [
    { value: BmpHomeOperatingSystem.WINDOWS, label: "Windows" },
    { value: BmpHomeOperatingSystem.CHROMIUM_OS, label: "ChromiumOS" },
    { value: BmpHomeOperatingSystem.MAC, label: "MAC" },
    { value: BmpHomeOperatingSystem.OTHER_HYPERVISORS, label: "Other Hypervisors" },
    { value: BmpHomeOperatingSystem.ANDROID, label: "Android" },
    { value: BmpHomeOperatingSystem.IOS, label: "iOS" },
    { value: BmpHomeOperatingSystem.IPAD_OS, label: "iPadOS" },
    { value: BmpHomeOperatingSystem.WEAR_OS, label: "wearOS" },
    { value: BmpHomeOperatingSystem.AGNOSTIC, label: "Agnostic" },
];

export const ALL_PROCESSOR_ITEMS = [
    { value: BmpHomeProcessor.X86_64, label: "x86/64" },
    { value: BmpHomeProcessor.WINDOWS_ARM, label: "Windows ARM" },
    { value: BmpHomeProcessor.T2_X86_64, label: "T2 (x86/64)" },
    { value: BmpHomeProcessor.APPLE_SILICON, label: "Apple Silicon (M1, M2, Mx)" },
    { value: BmpHomeProcessor.ARM, label: "ARM" },
];

export const USE_CASE_DEVICES: Record<BmpHomeUseCase, Set<BpmHomeTarget>> = {
    [BmpHomeUseCase.ENDPOINT]: new Set([
        BpmHomeTarget.LAPTOP_DESKTOP,
        BpmHomeTarget.FILE_ACTIVE_DATA,
        BpmHomeTarget.REMOVABLE_MEDIA,
        BpmHomeTarget.STORAGE,
    ]),
    [BmpHomeUseCase.DATA_CENTER]: new Set([
        BpmHomeTarget.SERVERS,
        BpmHomeTarget.LOOSE_DRIVES,
        BpmHomeTarget.STORAGE,
        BpmHomeTarget.STORAGE_ARRAY,
        BpmHomeTarget.VIRTUAL_MACHINE,
    ]),
    [BmpHomeUseCase.MOBILE]: new Set([
        BpmHomeTarget.SMARTPHONES,
        BpmHomeTarget.TABLETS,
        BpmHomeTarget.WEARABLES,
        BpmHomeTarget.AIRPOD,
    ]),
};

export const DEVICE_OPERATIONAL_SYSTEMS: Partial<Record<BpmHomeTarget, Set<BmpHomeOperatingSystem>>> = {
    [BpmHomeTarget.LAPTOP_DESKTOP]: new Set([
        BmpHomeOperatingSystem.WINDOWS,
        BmpHomeOperatingSystem.CHROMIUM_OS,
        BmpHomeOperatingSystem.MAC,
    ]),
    [BpmHomeTarget.FILE_ACTIVE_DATA]: new Set([BmpHomeOperatingSystem.WINDOWS]),
    [BpmHomeTarget.REMOVABLE_MEDIA]: new Set([BmpHomeOperatingSystem.WINDOWS]),
    [BpmHomeTarget.SERVERS]: new Set([BmpHomeOperatingSystem.WINDOWS, BmpHomeOperatingSystem.AGNOSTIC]),
    [BpmHomeTarget.VIRTUAL_MACHINE]: new Set([BmpHomeOperatingSystem.OTHER_HYPERVISORS]),
    [BpmHomeTarget.SMARTPHONES]: new Set([
        BmpHomeOperatingSystem.ANDROID,
        BmpHomeOperatingSystem.IOS,
        BmpHomeOperatingSystem.WINDOWS,
    ]),
    [BpmHomeTarget.TABLETS]: new Set([BmpHomeOperatingSystem.IPAD_OS, BmpHomeOperatingSystem.ANDROID]),
    [BpmHomeTarget.WEARABLES]: new Set([BmpHomeOperatingSystem.WEAR_OS, BmpHomeOperatingSystem.IOS]),
};

export const OS_PROCESSORS: Partial<Record<BmpHomeOperatingSystem, Set<BmpHomeProcessor>>> = {
    [BmpHomeOperatingSystem.WINDOWS]: new Set([
        BmpHomeProcessor.X86_64,
        BmpHomeProcessor.WINDOWS_ARM,
        BmpHomeProcessor.ARM,
    ]),
    [BmpHomeOperatingSystem.MAC]: new Set([BmpHomeProcessor.T2_X86_64, BmpHomeProcessor.APPLE_SILICON]),
    [BmpHomeOperatingSystem.AGNOSTIC]: new Set([BmpHomeProcessor.X86_64, BmpHomeProcessor.ARM]),
};
